export interface InreturnCredentials {
  inretrnUrl: string;
  inretrnToken: string;
}

export const getInreturnCredentials = (): InreturnCredentials => {
  switch (true) {
    case typeof window !== "undefined" &&
      window?.location?.hostname?.includes("localhost"):
    case typeof window !== "undefined" &&
      /miss-mary-.+run\.app/.test(window?.location?.hostname):
      return {
        inretrnUrl: "https://uat-returnsportal.inretrn.com/inretrn.js",
        inretrnToken: "OjptaXNzbWFyeQ==",
      };
    default:
      return {
        inretrnUrl: "https://returnsportal.inretrn.com/inretrn.js",
        inretrnToken: "OjptaXNzbWFyeQ",
      };
  }
};
